import { atom } from 'jotai';


const thesauriAtom = atom([]);

export { thesauriAtom };